import { URI } from '@/config/config';
import axios from 'axios';

export default async ({ rootState }, { licencePlate, vehicleId }) => {
  try {
    const token = rootState['DATA-ACCESS'].tokenAuth;

    const response = await axios.put(
      `${URI}vehicle/update-licence-plate/${vehicleId}`,
      {
        licencePlate,
      },
      {
        headers: {
          'user-token': rootState['DATA-ACCESS'].userToken,
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
